import React from 'react';
import {
  Accordion
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import InputField from '#component/form/input';
import RHFLegacyField from '#component/form/rhf/rhf-legacy-field';
import CustomFieldItemActions from '#component/project/form/custom-fields/custom-field-item/custom-field-item-actions';
import {
  PanelSummary,
  StyledAvatar,
  TitleContainer,
  StyledTitle,
  PanelDetails
} from './accordion-styles';

const AccordionItem = props => {
  const {
    index,
    member,
    remove,
    expanded,
    handleSetExpanded,
    item,
    forceError,
    children
  } = props;

  const deleteCustomFieldItem = event => {
    event.stopPropagation();
    remove(index);
  };

  return (
    <Accordion
      expanded={expanded}
      onChange={handleSetExpanded(member)}
      key={index}
    >
      <PanelSummary
        expandIcon={<ExpandMoreIcon />}
        aria-controls={`panel${index + 1}a-content`}
        id={`panel${index + 1}a-header`}
      >
        <TitleContainer>
          <StyledAvatar>{index + 1}</StyledAvatar>
          <StyledTitle>{item.label}</StyledTitle>
        </TitleContainer>
        <CustomFieldItemActions
          deleteCustomFieldItem={deleteCustomFieldItem}
          tooltipTitle="Delete custom field"
        />
      </PanelSummary>
      <PanelDetails>
        <RHFLegacyField
          name={`${member}.label`}
          component={InputField}
          placeholder="Custom field name"
          label="Field name"
          variant="outlined"
          forceError={forceError}
        />
        <div>
          {children}
        </div>
      </PanelDetails>
    </Accordion>
  );
};

export default AccordionItem;
